import { resourceEduCode } from '~/api/oneBoxV3/oneBoxV3.type';
import { FileCollection } from '~/types/enum';

export type TFileCatalogDetail = {
  education: string;
  filePath: string;
  key: string;
  fileSize: number;
  fileType: string;
  fileName: string;
  url?: string;
  fileUploadTime?: string;
  /** 資源 id（下載時寫入，舊紀錄可能沒有） */
  _id?: string;
  /** 實際落地的檔案路徑（實體檔名依 URL 命名，可能與顯示用檔名不同） */
  realPath?: string;
  /** 解壓後安裝出來的資料夾路徑（解壓完成時寫回，舊紀錄可能沒有） */
  installedPath?: string;
  grade: string;
  isOnlineSource: boolean;
  schoolYear: string;
  subject: string;
  eduCode: string;
  year: string;
  updateTime: number;
  resource1?: string;
  resource2?: string;
  resource3?: string;
  file: {
    fileSize: number;
    url: string;
    fileUploadTime: string;
  };
};

export type TFileCatalog = {
  [path: string]: TFileCatalogDetail;
};

export enum FileType {
  oneBook,
  tiku,
  flash,
}

export type TFileItem = {
  dist: string;
  folder: string;
  subFolder: string;
  type: FileType;
  img: string;
  fileName: string;
  exePath: string;
  opening: boolean;
};

export type TFileState = {
  oneBookFiles: string[];
  tikuFiles: string[];
  flashFiles: string[];
  fileCatalog: TFileCatalog;
  searchCondition: {
    eduCodes: resourceEduCode | null;
    years: string | null;
    grades: string | null;
    subjects: string | null;
  };
};

export type CollectionFileDetail<T> = T extends FileCollection.resource
  ? TFileCatalogDetail & { key: string }
  : {
      dist: string;
      folder: string;
      subFolder: string;
      key: string;
      folderPath: string;
      type: FileType;
      img: string;
      fileName: string;
      exePath: string;
      opening: boolean;
    };
